// src/hooks/common/useModal.ts
import {useSelector, useDispatch} from "react-redux";
import {useCallback} from "react";
import {
  selectModalOpen,
  openModal,
  closeModal,
  toggleModal,
} from "../../store/slices/uiSlice";

export const useModal = (modalKey: string) => {
  const dispatch = useDispatch();
  const isOpen = useSelector(selectModalOpen(modalKey));

  const open = useCallback(() => {
    dispatch(openModal(modalKey));
  }, [dispatch, modalKey]);

  const close = useCallback(() => {
    dispatch(closeModal(modalKey));
  }, [dispatch, modalKey]);

  const toggle = useCallback(() => {
    dispatch(toggleModal(modalKey));
  }, [dispatch, modalKey]);

  return {
    isOpen,
    open,
    close,
    toggle,
  };
};
